module.exports = __webpack_public_path__ + "img/battery-2.84d629f8.png";